(function () {
  const STORAGE_KEY = 'sole:wishlist';
  const CHANGE_EVENT = 'wishlist:change';

  function read() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function write(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (error) {
      /* localStorage unavailable (private mode, quota, etc.) — fail silently */
    }
    document.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: { handles } }));
  }

  window.SoleWishlist = {
    all() {
      return read();
    },
    has(handle) {
      return read().includes(handle);
    },
    toggle(handle) {
      const handles = read();
      const index = handles.indexOf(handle);
      if (index > -1) {
        handles.splice(index, 1);
      } else {
        handles.push(handle);
      }
      write(handles);
      return handles.includes(handle);
    },
    remove(handle) {
      write(read().filter((existing) => existing !== handle));
    },
    count() {
      return read().length;
    },
  };

  class WishlistButton extends HTMLElement {
    connectedCallback() {
      this.handle = this.dataset.productHandle;
      this.button = this.querySelector('button');
      this.addLabel = this.dataset.addLabel;
      this.removeLabel = this.dataset.removeLabel;

      this.render();

      this.onClick = this.onClick.bind(this);
      this.onWishlistChange = this.onWishlistChange.bind(this);

      this.button.addEventListener('click', this.onClick);
      document.addEventListener(CHANGE_EVENT, this.onWishlistChange);
    }

    disconnectedCallback() {
      document.removeEventListener(CHANGE_EVENT, this.onWishlistChange);
    }

    onClick(event) {
      event.preventDefault();
      event.stopPropagation();
      window.SoleWishlist.toggle(this.handle);
    }

    onWishlistChange() {
      this.render();
    }

    render() {
      const active = window.SoleWishlist.has(this.handle);
      this.setAttribute('data-active', active);
      this.button.setAttribute('aria-pressed', String(active));
      this.button.setAttribute('aria-label', active ? this.removeLabel : this.addLabel);
    }
  }

  if (!customElements.get('wishlist-button')) {
    customElements.define('wishlist-button', WishlistButton);
  }

  function updateWishlistBubble() {
    const bubble = document.querySelector('[data-wishlist-count]');
    if (!bubble) return;
    const count = window.SoleWishlist.count();
    const countLabel = bubble.querySelector('[data-wishlist-count-value]');
    if (countLabel) countLabel.textContent = count;
    bubble.hidden = count === 0;
  }

  document.addEventListener(CHANGE_EVENT, updateWishlistBubble);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateWishlistBubble);
  } else {
    updateWishlistBubble();
  }
})();
